import { Suspense, useMemo } from "react";
import { RelativeComponentLoader } from "@/components/loader";
import classes from "../summary.module.scss";
import useSummaryState from "../useSummaryState";
import { TaskLabels, TeamMatesConfig } from "@altimateai/ui-components/teammate";
import { IconButton } from "@altimateai/lego";
import { CloseIcon } from "@/assets/icons";
import { useSelectedInstance, useSummaryDispatch } from "../SummaryNew";
import { setShowChatbot } from "../context/summarySlice";
import { ChatProvider, ChatSession } from "@altimateai/ui-components/chatbotV2";
import { API_URL } from "@/config";
import { Feedback } from "@/components/feedback/Feedback";
import { toast } from "react-toastify";
import useAppContext from "@/modules/app/useAppContext";
import useAppActions from "@/modules/app/useAppActions";

const SummaryChatbot = () => {
  const { showChatbot } = useSummaryState();
  const summaryDispatch = useSummaryDispatch();
  const { dispatch } = useAppContext();
  const { getCommonHeaders } = useAppActions(dispatch);

  const instance = useSelectedInstance();

  const showSummaryChatBot = showChatbot !== undefined;

  const askPath = useMemo(() => {
    if (instance && instance !== "all") {
      return `/summary/v2/datapilot/start-chart-chat?instance_id=${instance}`;
    }
    return "/summary/v2/datapilot/start-chart-chat";
  }, [instance]);

  if (!showSummaryChatBot) {
    return;
  }

  const { helloMessage, ...params } = showChatbot;

  const chartAnalyserBot = TeamMatesConfig.find(t => t.key === TaskLabels.ChartBot);

  const assistantMeta = chartAnalyserBot
    ? { avatar: chartAnalyserBot.avatar, name: chartAnalyserBot.name }
    : undefined;

  const closeSummaryChatbot = () => {
    summaryDispatch(setShowChatbot(undefined));
  };

  const validateRequest = async (data: { context: ChatSession["context"] }) => {
    console.log(data);
  };

  const headers = getCommonHeaders();

  return (
    <div className={classes.summaryChatbot}>
      <Suspense fallback={<RelativeComponentLoader label={"Loading Chatbot"} />}>
        <IconButton
          variant="ghost"
          title="Close chatbot"
          className="al-absolute al-right-[10px] al-top-[10px] al-bg-gray-400 hover:al-bg-gray-500 !al-rounded-full al-w-fit al-h-fit al-p-1"
          onClick={closeSummaryChatbot}
        >
          <CloseIcon />
        </IconButton>
        <ChatProvider
          assistantMeta={assistantMeta}
          helloMessage={helloMessage}
          initialValidation={validateRequest}
          taskLabel={TaskLabels.ChartBot}
          context={params}
          urls={{
            origin: API_URL,
            askPath,
            proceedPath: askPath,
            frontendUrl: window.location.origin,
            followupPath: "/summary/v2/datapilot/follow-up-questions-chart-chat",
          }}
          disableContext
          requestParams={{
            headers,
          }}
          components={{
            feedback: (
              <Feedback
                feedback_id={`summary-${Date.now()}`}
                feedback_type={`summary`}
                resetWorkflow={() => {}}
                afterSubmit={() => {
                  toast("Thank you for your feedback!");
                }}
                hideTitle
                className="!al-bg-transparent !al-p-0"
              />
            ),
          }}
        />
      </Suspense>
    </div>
  );
};

export default SummaryChatbot;
